module.exports = __webpack_public_path__ + "img/photo-0136.3bd4e869.jpg";